import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "../store/states/app";
import { selectTimerState } from "../store/selectors/timer";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ClockService {
  private syncServerTime: number;
  private syncMonotonicMs: number;
  private currentDateTimer;
  private subj;

  constructor(private _store: Store<IAppState>) {
    this.subj = new BehaviorSubject(0);
    this._store.select(selectTimerState).subscribe((resp) => {
      this.syncServerTime = resp.serverTime;
      this.syncMonotonicMs = performance.now();
      this.startTimer();
    });
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        this.emitNow();
      }
    });
  }

  private currentServerTime(): number {
    return this.syncServerTime + (performance.now() - this.syncMonotonicMs) / 1000;
  }

  private emitNow() {
    this.subj.next(Math.floor(this.currentServerTime()));
  }

  startTimer() {
    clearInterval(this.currentDateTimer);
    this.emitNow();
    this.currentDateTimer = setInterval(() => this.emitNow(), 1000);
  }

  get clock() {
    return this.subj as Observable<any>;
  }
}
